import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '4',
    view: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
  activeItem: {},
};

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    blogStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //   opacity: itemDesign.opacity ?? 0,
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.containerDesign = containerDesign ?? {};
      state.itemDesign = itemDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        layout: Number(blockDesign.layout) ?? '4',
        view: blockDesign.view ?? 'feed',
      };
    },
    blogClear: () => initialState,

    blogUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    blogUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    blogUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    blogUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    blogUpdateActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
  },
});

export const { blogStore, blogClear, blogUpdateIsLoading, blogUpdateIsActive, blogUpdateBlockContent, blogUpdateBlockDesign, blogUpdateActiveItem } = blogSlice.actions;

export const selectBlogIsLoading = (state) => state.blog.isLoading;

export const selectBlogId = (state) => state.blog.id;
export const selectBlogUID = (state) => state.blog.uid;
export const selectBlogSID = (state) => state.blog.sid;

export const selectBlogBlockContent = (state) => state.blog.blockContent;
export const selectBlogBlockDesign = (state) => state.blog.blockDesign;
export const selectBlogSortItems = createSelector([selectBlogBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectBlogItemDesign = (state) => state.blog.itemDesign;
export const selectBlogContainerDesign = (state) => state.blog.containerDesign;

export const selectBlogActiveItem = (state) => state.blog.activeItem;

export default blogSlice.reducer;
